<template>
  <div class="empty">
    <h4>{{ title }}</h4>
    <slot name="button"> </slot>
  </div>
</template>

<script>
export default {
  name: "emptyView",
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_empty.scss";
</style>
